import { OperatorFunction, of, throwError } from "rxjs";
import notify from "devextreme/ui/notify";
import { catchError } from "rxjs/operators";
import { isUndefined } from "is-what";
import { BrdLoggerService } from "@board/cloud-library/components/services";

export function brdCatchError<T>(defaultAction?: (error) => T): OperatorFunction<T, T> {
  return catchError(error => {
    if (error.status === 422) {
      // errore da chiamata server con status 422
      notify({
        message: error.error.message,
        type: "error",
        displayTime: 5000,
        maxWidth: 500,
        position: "top center",
        closeOnClick: true
      });
      return of();
    } else if (isUndefined(defaultAction)) {
      return throwError(error);
    } else {
      BrdLoggerService.instance.warn(error);
      return of(defaultAction(error));
    }
  });
}
